<template>
  <div>
    <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
      <v-list shaped dense>
        <v-subheader>HORÁRIOS</v-subheader>
        <v-list-item-group
          color="primary"
          v-model="selectedItemTimesheet"
          mandatory
          v-for="item in items"
          :key="item.text"
        >
          <router-link :to="item.routerLinkName" exact-active-class>
            <v-list-item link>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <v-subheader>CONFIGURAÇÕES</v-subheader>
          <router-link :to="{ name: 'home/registered-classes' }">
            <v-list-item color="primary" link>
              <v-list-item-action>
                <v-icon>mdi-calendar-edit</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Aulas cadastradas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="{ name: 'home/general-config' }">
            <v-list-item color="primary" link>
              <v-list-item-action>
                <v-icon>mdi-cog</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Geral</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-navigation-drawer v-model="right" fixed right temporary>
      <v-system-bar></v-system-bar>
      <units :value="this.currentUnit"></units>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="blue darken-3" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn icon large class="pl-4">
        <v-avatar size="32px" item>
          <v-img src="@/assets/logo-poli.svg" alt="Polisystem"></v-img>
        </v-avatar>
      </v-btn>

      <v-toolbar-title style="width: 300px" class="ml-0 pl-2">
        <span class="hidden-sm-and-down">Controle de Audiência</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn small outlined @click="right = true">
        {{ currentUnit.idPolinex }} -
        {{ currentUnit.name }}
      </v-btn>
      <v-progress-linear
        :active="loading"
        :indeterminate="true"
        absolute
        bottom
        color="primary lighten-2"
      ></v-progress-linear>
    </v-app-bar>

    <v-main class="fill-height" fluid>
      <transition name="fade" mode="out-in">
        <router-view name="navigation"></router-view>
      </transition>
    </v-main>

    <v-btn bottom color="pink" dark fab fixed left @click="newGymClassDialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <show-class />
  </div>
</template>

<script>
//import inlineCalendar from "@/components/InlineCalendar";
//import calendarListItem from "@/components/CalendarListItem";
import showClass from "../show-class/ShowClass";

import Units from "../units/Units";

import { mapState, mapActions } from "vuex";

export default {
  name: "Home",
  components: {
    showClass,
    Units,
  },
  data: () => ({
    loading: true,
    newGymClass: {},
    myDialogVisible: false,
    right: false,
    drawer: null,
    selectedItemTimesheet: 0,
    items: [
      {
        icon: "mdi-calendar-clock",
        text: "Agenda de horários",
        routerLinkName: "class-schedules",
      },
      //{ icon: "mdi-arm-flex", text: "Sala de musculação" }
      //{ heading: "CONFIGURAÇÕES" },
      //{ icon: "mdi-arm-flex", text: "Aulas cadastradas" }
    ],
  }),
  mounted() {
    try {
      this.ActionGetCurrentUnit();

      let u = this.user.managerUnits.find(
        (item) => item.unitId === this.currentUnit.id
      );
      if (u == null) this.ActionSetCurrentUnit(this.user.managerUnits[0].unit);
      //else this.ActionSetCurrentUnit(u.unit);
    } catch (err) {
      this.ActionDeleteCurrentUnit();
    } finally {
      this.loading = false;
    }
    if (this.$router.currentRoute.name !== "home/class-schedules")
      this.$router.push({ name: "home/class-schedules" });
  },
  created() {},
  methods: {
    ...mapActions("units", [
      "ActionGetCurrentUnit",
      "ActionSetCurrentUnit",
      "ActionDeleteCurrentUnit",
    ]),

    ...mapActions("showClass", ["ActionSetShowClassDialog", "ActionSetClass"]),

    myDialogClose() {
      this.myDialogVisible = false;
    },
    newGymClassDialog() {
      this.newGymClass = {
        id: 0,
        unitId: this.currentUnit.id,
        allowsSchedule: true,
        classSchedules: [],
        classType: -1,
        isActive: true,
        maxCapacity: "",
        name: "",
        unit: null,
      };
      this.ActionSetClass(this.newGymClass);
      this.ActionSetShowClassDialog(true);
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("units", ["currentUnit"]),
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
